import { Address } from 'viem';

import { api, cacheTags } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { asAddress } from 'modules/api/utils/asAddress';
import { getWalletClient } from 'modules/api/walletClient';

import { getPendingUnstakes } from '../methods/getPendingUnstakes';
import { IPoolUnstake } from '../types';

interface IGetPoolArgs {
  poolAddress: Address;
}

export const EMPTY_POOL_UNSTAKES: IPoolUnstake[] = [];

export const {
  useGetPoolPendingUnstakesQuery,
  endpoints: { getPoolPendingUnstakes: getPoolPendingUnstakesEndpoint },
} = api.injectEndpoints({
  endpoints: build => ({
    getPoolPendingUnstakes: build.query<IPoolUnstake[], IGetPoolArgs>({
      queryFn: async ({ poolAddress }) => {
        const publicClient = getPublicClient();
        const walletClient = getWalletClient();

        return {
          data: await getPendingUnstakes(publicClient, {
            poolAddresses: [poolAddress],
            accountAddress: asAddress(walletClient.account?.address),
          }),
        };
      },
      providesTags: [cacheTags.account, cacheTags.unstake, cacheTags.claim],
    }),
  }),
});
